<template>
  <div>
    <div
      class="event-detail"
      v-if="EventDetail && Object.keys(EventDetail).length"
    >
      <div class="content">
        <div class="event-detail__title" v-html="EventDetail.name"></div>
      </div>
      <Breadcrumbs
        :pages="[
          {
            name: EventDetail.name,
          },
        ]"
        :color="'#0194AC'"
      />
      <div class="content">
        <picture>
          <source
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/banner_mob.jpg`"
            media="(max-width: 767px)"
          />
          <source
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/banner_tab.jpg`"
            media="(max-width: 1220px)"
          />
          <source
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/banner.jpg`"
            media="(min-width: 1221px)"
          />
          <img
            class="event-detail__banner mt-8"
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/banner.jpg`"
          />
        </picture>

        <div class="event-detail__timer mt-8">
          <video
            controls
            :src="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/video/2023/06/20/Авдеев С.Н. ХОБЛ сейчас_ в мире и в РФ-min.mp4`"
            :poster="`https://storage.yandexcloud.net/${$root.backetName}/media/content/video/Авдеев С.Н. ХОБЛ сейчас_ в мире и в РФ.png`"
          ></video>
        </div>
        <div class="event-detail__body">
          <div class="event-detail__main-info">
            <div class="event-detail__description-block">
              <div class="_mr-8">
                <div class="event-detail__about-title">О мероприятии</div>
                <div class="event-detail__about-description">
                  Приглашаем вас присоединиться к встрече экспертов - «Время
                  ХОБЛ: изменить, лечить, действовать».
                  <br />
                  <br />
                  Обсудим ХОБЛ, современные подходы к терапии и представим новый
                  препарат «Брезтри Аэросфера».
                </div>
              </div>
              <picture>
                <source
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/medication_mob.png`"
                  media="(max-width: 767px)"
                />
                <source
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/medication_tab.png`"
                  media="(max-width: 1220px)"
                />
                <source
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/medication.png`"
                  media="(min-width: 1221px)"
                />
                <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/breztri/medication.png`" />
              </picture>
            </div>
            <div class="mt-6">
              <div class="hobl-activities__title">
                Эксперты о Брезтри Аэросфера
              </div>
              <video
                controls="controls"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/video/2023/06/28/%D0%AD%D0%BA%D1%81%D0%BF%D0%B5%D1%80%D1%82%D1%8B_%D0%BE_%D0%91%D1%80%D0%B5%D0%B7%D1%82%D1%80%D0%B8_%D0%90%D1%8D%D1%80%D0%BE%D1%81%D1%84%D0%B5%D1%80%D0%B0-min.mp4`"
                :poster="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/announce/2023/06/27/2023-06-27_14-17-43.png`"
              ></video>
            </div>
            <div class="mt-6">
              <div class="hobl-activities__title">
                Что нового в терапии ХОБЛ? GOLD 23 обзор международных
                рекомендаций
              </div>
              <video
                controls="controls"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/video/2023/07/27/%D0%A7%D1%82%D0%BE__%D0%BD%D0%BE%D0%B2%D0%BE%D0%B3%D0%BE_%D0%B2_%D1%82%D0%B5%D1%80%D0%B0%D0%BF%D0%B8%D0%B8_%D0%A5%D0%9E%D0%91%D0%9B__GOLD_23_%D0%BE%D0%B1%D0%B7%D0%BE%D1%80_%D0%BC%D0%B5%D0%B6%D0%B4%D1%83%D0%BD%D0%B0%D1%80%D0%BE%D0%B4%D0%BD_bplgiam.mp4`"
                :poster="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/announce/2023/07/27/%D0%A7%D1%82%D0%BE__%D0%BD%D0%BE%D0%B2%D0%BE%D0%B3%D0%BE_%D0%B2_%D1%82%D0%B5%D1%80%D0%B0%D0%BF%D0%B8%D0%B8_%D0%A5%D0%9E%D0%91%D0%9B___GOLD_23_%D0%BE%D0%B1%D0%B7%D0%BE%D1%80_%D0%BC%D0%B5%D0%B6%D0%B4%D1%83%D0%BD_faVjtEb.jpeg`"
              ></video>
            </div>
            <div class="mt-6">
              <div class="hobl-activities__title">
                Архипов В.В. - Что такое Аэросфера
              </div>
              <video
                controls="controls"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/video/2023/09/04/%D0%90%D1%80%D1%85%D0%B8%D0%BF%D0%BE%D0%B2_%D0%92.%D0%92._-_%D0%A7%D1%82%D0%BE_%D1%82%D0%B0%D0%BA%D0%BE%D0%B5_%D0%90%D1%8D%D1%80%D0%BE%D1%81%D1%84%D0%B5%D1%80%D0%B0-min.mp4`"
                :poster="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/announce/2023/09/04/%D0%90%D1%80%D1%85%D0%B8%D0%BF%D0%BE%D0%B2_%D0%92.%D0%92._-_%D0%A7%D1%82%D0%BE_%D1%82%D0%B0%D0%BA%D0%BE%D0%B5_%D0%90%D1%8D%D1%80%D0%BE%D1%81%D1%84%D0%B5%D1%80%D0%B0.jpeg`"
              ></video>
            </div>

            <div class="mt-6">
              <div class="hobl-activities__title">
                Синопальников А.И. - Брезтри Аэросфера - три активных компонента
                для свободного дыхания
              </div>
              <video
                controls="controls"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/video/2023/09/04/%D0%A1%D0%B8%D0%BD%D0%BE%D0%BF%D0%B0%D0%BB%D1%8C%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2_%D0%90.%D0%98._-_%D0%91%D1%80%D0%B5%D0%B7%D1%82%D1%80%D0%B8_%D0%90%D1%8D%D1%80%D0%BE%D1%81%D1%84%D0%B5%D1%80%D0%B0_-_%D1%82%D1%80%D0%B8_%D0%B0%D0%BA%D1%82%D0%B8%D0%B2%D0%BD%D1%8B%D1%85_qXw9ZMN.mp4`"
                :poster="`https://storage.yandexcloud.net/${$root.backetName}/media/uploads/materials/announce/2023/09/04/%D0%A1%D0%B8%D0%BD%D0%BE%D0%BF%D0%B0%D0%BB%D1%8C%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2_%D0%90.%D0%98._-_%D0%91%D1%80%D0%B5%D0%B7%D1%82%D1%80%D0%B8_%D0%90%D1%8D%D1%80%D0%BE%D1%81%D1%84%D0%B5%D1%80%D0%B0_-_%D1%82%D1%80%D0%B8_%D0%B0%D0%BA%D1%82%D0%B8_K6PMUzA.jpeg`"
              ></video>
            </div>

            <!-- <div class="event-detail__about-title">Расписание и лекторы</div>
            <InfoDrop
              @openInner="openInner"
              :item="{
                title: 'Программа на 27 мая',
                content: galaxyProgramm,
              }"
            /> -->
            <div class="hobl-activities mt-8">
              <div class="hobl-activities__title">Интерактивы</div>
              <div class="hobl-activities__description">
                В период ожидания эфира, мы предлагаем вам пройти несколько
                полезных активностей
              </div>
              <div class="hobl-activities__list">
                <div class="hobl-activities__item">
                  <div class="hobl-activity__icon">
                    <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/galaxy/icons/3.svg`" />
                  </div>
                  <div
                    class="hobl-activity__button button"
                    @click="
                      toWidget(
                        {
                          name: 'TimeHoblFrame',
                          params: { frame: 'find_word' },
                        },
                        'Найдите слова'
                      )
                    "
                  >
                    Найдите слова
                  </div>
                </div>
                <div class="hobl-activities__item">
                  <div class="hobl-activity__icon">
                    <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/galaxy/icons/2.svg`" />
                  </div>
                  <div
                    class="hobl-activity__button button"
                    @click="
                      toWidget(
                        {
                          name: 'TimeHoblFrame',
                          params: { frame: 'share' },
                        },
                        ' Делитесь ссылками'
                      )
                    "
                  >
                    Делитесь ссылками
                  </div>
                </div>
              </div>
            </div>
            <div class="event-detail__tip">
              ХОБЛ — хроническая обструктивная болезнь легких <br /><br />
              СЗЗ — социально-значимое заболевание <br /><br />
              РФ — Российская федерация<br /><br />

              Инструкция по медицинскому применению лекарственного препарата
              Брезтри Аэросфера 160 мкг + 7,2 мкг + 5,0 мкг/доза (аэрозоль для
              ингаляций дозированный). Регистрационное удостоверение ЛП-N001229
              от 19.09.2022. С полной инструкцией по медицинскому применению
              лекарственного препарата Брезтри Аэросфера можно ознакомиться по
              ссылке
              <a href="https://az-most.ru/medication/breztri-aehrosfera"
                >https://az-most.ru/medication/breztri-aehrosfera.</a
              >
            </div>
            <div
              class="event-detail__iframe mb-8"
              v-if="
                ((IframeAccess &&
                  Object.keys(IframeAccess).length &&
                  IframeAccess[`event_${EventDetail.id}`] &&
                  Object.keys(IframeAccess[`event_${EventDetail.id}`])
                    .length) ||
                  EventDetail.webinar_id) &&
                !Object.keys(timerResult).length &&
                openFrame
              "
              :class="{ 'event-detail__iframe_opened': openFrame }"
            >
              <div
                @click="openFrame = false"
                v-if="openFrame"
                class="event-detail__close-btn"
              >
                <span class="button button_pink button_small">Назад</span>
                <!-- <svg
                  class="d-xl-none"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.25 5.25L18.75 18.75"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  ></path>
                  <path
                    d="M18.75 5.25L5.25 18.75"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  ></path>
                </svg> -->
              </div>
              <iframe
                v-if="
                  IframeAccess &&
                  IframeAccess[`event_${EventDetail.id}`] &&
                  Object.keys(IframeAccess[`event_${EventDetail.id}`]).length
                "
                class="d-xl-block"
                id="userplayer"
                frameborder="0"
                :src="
                  IframeAccess[`event_${EventDetail.id}`].url +
                  '&lang=Ru-ru&disableSupport=1'
                "
                allow="camera;microphone;fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;display-capture;"
                allowusermedia
              ></iframe>
              <iframe
                v-else
                class="d-xl-block"
                id="userplayer"
                frameborder="0"
                :src="`https://edu.livedigital.space/room/${
                  EventDetail.webinar_id
                }/?participantName=${
                  $route.query.email || ''
                }&lang=Ru-ru&disableSupport=1`"
                allow="camera;microphone;fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;display-capture;"
                allowusermedia
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <PopupEnd
        @close="closePopup"
        v-if="popup && $route.query.access"
      />
      <PopUpDefault @close="popupActivity = false" v-if="popupActivity">
        <div class="popup__text">
          Данный интерактив будет доступен 18&#8209;го&nbsp;мая
        </div>
      </PopUpDefault>
    </div>
    <div v-else-if="EventDetail === 404"><Choch class="inPage" /></div>
    <div v-else-if="EventDetail === false"><Error class="inPage" /></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "../../components/pageComponents/Breadcrumbs.vue";
import InfoDrop from "../../components/pageComponents/InfoDrop.vue";
import PopupEnd from "@/components/pageComponents/PopUpEventEnd.vue";
import PopUpDefault from "@/components/pageComponents/PopUpDefault.vue";
import Choch from "@/views/404.vue";
import Error from "@/views/Error.vue";
export default {
  metaInfo() {
    if (this.EventDetail.name) {
      return {
        title: "Az-most - " + this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
      };
    } else {
      return { title: "Az-most - " + this.EventDetail.name };
    }
  },
  name: "EventDetail",
  components: { Breadcrumbs, InfoDrop, Choch, Error, PopupEnd, PopUpDefault },
  data: () => ({
    popup: false,
    popupActivity: false,
    openFrame: false,
    timerResult: { id: 0 },
    timerResultEnd: {},
    interval: null,
    intervalEnd: null,
    percent: null,
  }),
  computed: {
    ...mapGetters(["user", "IframeAccess"]),
    EventDetail() {
      return {
        id: 222,
        types: [
          {
            id: 1,
            name: "Онлайн",
            code: "online",
          },
          {
            id: 2,
            name: "Оффлайн",
            code: "offline",
          },
        ],
        name: "Время ХОБЛ: изменить, лечить, действовать.",
        description: "",
        banner_description:
          "10:00 – 10:10 – «Липидная теория атеросклероза» 110 лет за 10 минут – Сусеков А.В.<br><br>10:10 – 10:30 - Программа «Галактика» в 2023 г: результаты тысяч пациентов и для уверенного решения Обрезан А.Г. (Санкт-Петербург)<br><br>10:30 – 10:50 - Безопасность терапии статинами - сквозь туманность сомнений и противоречий. Бубнова М.Г.<br><br>10:50 – 11:10 - Рекомендации 2023 по липидам: большой взрыв или вспышки на солнце? – Кобалава Ж.Д.<br><br>11:10 – 11:30 - Созвездие нестатиновой терапии: белые карлики, погасшие звезды и сверхновые. Навигация для врачей. Каштолап В.В. (Кемерово)<br><br>11:30 – 11:50 - Отклонение от статиновой орбиты и как вернуться на верный курс? – Скибицкий В.В. (Краснодар)<br><br>11:50 – 12:10 - Космический шум и информационное поле – почему важен диалог с пациентом? Воробьёв А.С. (Сургут)<br><br>12:10 – 12:30 - Дискуссия экспертов",
        date: "2023-05-27T10:30:30+03:00",
        date_end: "2029-05-27T16:30:31+03:00",
        place: "",
        webinar_id: "Hqdjk63Rgp",
        room_id: "646de4fc3bb5f4be74bb5e66",
      };
    },
    program() {
      return [
        {
          time: "10:30 – 10:50",
          title: "ХОБЛ сейчас: в мире и в РФ",
          description: "Авдеев Сергей Николаевич",
        },
        {
          time: "10:50 – 11:10",
          title:
            "Обострения как основное проявление ХОБЛ, влияющее на смертность",
          description: "Титова Ольга Николаевна",
        },
        {
          time: "11:15 – 11:45",
          title:
            "Что нового в терапии ХОБЛ? GOLD 23 — обзор международных рекомендаций",
          description: "Айсанов Заурбек Рамазанович",
        },
        {
          time: "11:45 – 12:00",
          title: "Дискуссия",
          icon: "talking",
          description: "",
        },
        {
          time: "12:00 – 12:15",
          title: "Перерыв",
          icon: "coffee",
          description: "",
        },
        {
          time: "12:15 – 12:45",
          title:
            "Брезтри Аэросфера — три активных компонента для свободного дыхания",
          description: "Синопальников Александр Игоревич",
        },
        {
          time: "12:45 – 13:00",
          title: "Что такое Аэросфера?",
          description: "Архипов Владимир Владимирович",
        },
        {
          time: "13:00 – 13:15",
          title: "Кому необходимо назначить препарат Брезтри Аэросфера?",
          description: "Княжеская Надежда Павловна",
        },
        {
          time: "13:15 – 13:30",
          title: "Дискуссия",
          icon: "talking",
          description: "",
        },
        {
          time: "13:30 – 14:30",
          title: "Перерыв",
          icon: "coffee",
          description: "",
        },
        {
          time: "14:30 – 14:50",
          title: "Взгляд терапевта на проблему ХОБЛ",
          description: "Малявин Андрей Георгиевич",
        },
        {
          time: "14:50 – 15:10",
          title: "Взгляд кардиолога на проблему ХОБЛ",
          description: "Адашева Татьяна Владимировна",
        },
        {
          time: "15:10 – 15:25",
          title: "Дискуссия",
          icon: "talking",
          description: "",
        },
        {
          time: "15:25 – 15:50",
          title: "Перерыв",
          icon: "coffee",
          description: "",
        },
        {
          time: "15:50 – 16:10",
          title: "Проект новых клинических рекомендаций ХОБЛ",
          description: "Лещенко Игорь Викторович",
        },
        {
          time: "16:10 – 16:30",
          title: "Дискуссия и подведение итогов",
          icon: "talking",
          description: "",
        },
      ];
    },

    galaxyProgramm() {
      let html = ``;
      let block = ``;
      for (let item of this.program) {
        block += `
              <div class="hobl__program-item">
                <div class="hobl__program-time">${item.time}</div>
                <div class="d-flex align-start hobl__program-info">
                  <img class="mr-2" src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/breztri/icons/${
                    item.icon || "person"
                  }.svg"  />
                  <div class="hobl__program-info my-auto">
                    <div class="hobl__program-title">
                    ${item.title}
                    </div>
                    <div style="${
                      item.description ? "" : "display: none"
                    }" class="hobl__program-description">
                      ${item.description}
                    </div>
                  </div>
                </div>
              </div>
            </div>`;
      }
      html = `<div class="hobl__program mb-8">${block}</div>`;
      return html;
    },
  },
  methods: {
    ...mapActions(["fetchEventsCalendar", "fetchIframeAccess"]),
    openInner() {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "see broadcast programm click", {
          "see broadcast programm click": {
            ...this.$root.ymFields,
          },
        });
      }
    },
    toWidget(to, name, closed) {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "galaxy widget click", {
          "galaxy widget click": {
            "galaxy widget name": name,
            ...this.$root.ymFields,
          },
        });
      }
      if (!closed) {
        this.$router.push(to).catch(() => {});
      } else {
        this.popupActivity = true;
      }
    },
    timer() {
      let date = new Date();
      const dateEnd = this.$m
        .utc(this.EventDetail.date)
        .utcOffset(+3)
        .subtract(10, "minutes");
      const today = this.$m.utc(date).utcOffset(+3);
      const diff = today.diff(dateEnd, "seconds");
      this.$set(this, "timerResult", {});
      if (diff > 0) return;
      let months = Math.abs(diff) / 2592000;
      let fullMonths = Math.floor(months);
      let days = (months - Math.floor(months)) * 30;
      let fullDays = Math.floor(days);
      let hours = (days - Math.floor(days)) * 24;
      let fullHours = Math.floor(hours);
      let minutes = (hours - Math.floor(hours)) * 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.$set(this, "timerResult", {});
      if (fullMonths) {
        this.$set(this.timerResult, "months", fullMonths);
      }
      if (fullDays) {
        this.$set(this.timerResult, "days", fullDays);
      }
      if (fullHours) {
        this.$set(this.timerResult, "hours", fullHours);
      }
      if (fullMinutes) {
        this.$set(this.timerResult, "minutes", fullMinutes);
      }
      if (fullSeconds) {
        this.$set(this.timerResult, "seconds", fullSeconds);
      }
    },
    timerEnd() {
      let date = new Date();
      const dateEnd = this.$m.utc(this.EventDetail.date_end).utcOffset(+3);
      const today = this.$m.utc(date).utcOffset(+3);
      const diff = today.diff(dateEnd, "seconds");
      if (diff > 0) return;
      let months = Math.abs(diff) / 2592000;
      let fullMonths = Math.floor(months);
      let days = (months - Math.floor(months)) * 30;
      let fullDays = Math.floor(days);
      let hours = (days - Math.floor(days)) * 24;
      let fullHours = Math.floor(hours);
      let minutes = (hours - Math.floor(hours)) * 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.$set(this, "timerResultEnd", {});
      if (fullMonths) {
        this.$set(this.timerResultEnd, "months", fullMonths);
      }
      if (fullDays) {
        this.$set(this.timerResultEnd, "days", fullDays);
      }
      if (fullHours) {
        this.$set(this.timerResultEnd, "hours", fullHours);
      }
      if (fullMinutes) {
        this.$set(this.timerResultEnd, "minutes", fullMinutes);
      }
      if (fullSeconds) {
        this.$set(this.timerResultEnd, "seconds", fullSeconds);
      }
      
    },
    async getCalendar(id) {
      const url = await this.fetchEventsCalendar(id);
      let a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = url;
      a.download = "event.ics";
      a.click();
      setTimeout(async () => {
        window.URL.revokeObjectURL(url);
      }, 1000);
      a.remove();
    },
   
    closePopup() {
      this.popup = false;
    },
    
    openIframe() {
      if (
        !localStorage.getItem("token") &&
        !!!Object.keys(this.user).length &&
        !!this.$route.query.access
      ) {
        this.openFrame = true;
      } else {
        this.openFrame = true;
      }
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "watch broadcast click", {
          "watch broadcast click": {
            ...this.$root.ymFields,
          },
        });
      }
    },
    cyclicVideo(duration) {
      const vm = this;
      this.timer = setTimeout(() => {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "video 30 sec", {
            "video 30 sec": {
              "video name": vm.EventDetail.name,
              "video duration": duration,
              ...this.$root.ymFields,
            },
          });
        }
        vm.cyclicVideo();
      }, 30000);
    },
  },
  async mounted() {
    const vm = this;
    this.interval = setInterval(this.timer, 1000);
    this.intervalEnd = setInterval(this.timerEnd, 1000);
    const today = this.$m.utc(new Date()).utcOffset(+3);
    const dateEnd = this.$m
      .utc(this.EventDetail.date_end)
      .utcOffset(+3)
      .add(1, "hours");
    const diff = today.diff(dateEnd, "seconds");
    if (diff > 0) {
      this.$router.push({ name: "Events" });
    }
    let video = document.querySelector(".event-detail__timer video");
    if (video) {
      video.addEventListener("play", function () {
        if (this.currentTime === 0) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video start", {
              "video start": {
                "video name": vm.EventDetail.name,
                "video duration": Math.round(this.duration),
                ...vm.$root.ymFields,
              },
            });
          }
        } else {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video resume", {
              "video resume": {
                "video name": vm.EventDetail.name,
                "video duration": Math.round(this.duration),
                ...vm.$root.ymFields,
              },
            });
          }
        }
        vm.cyclicVideo(Math.round(this.duration));
      });
      video.addEventListener("pause", function () {
        if (this.currentTime !== this.duration) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video pause", {
              "video pause": {
                "video name": vm.EventDetail.name,
                "video duration": Math.round(this.duration),
                ...vm.$root.ymFields,
              },
            });
          }
        }
        clearTimeout(vm.timer);
        vm.timer = null;
      });
      video.addEventListener("ended", function () {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "video end", {
            "video end": {
              "video name": vm.EventDetail.name,
              "video duration": Math.round(this.duration),
              ...vm.$root.ymFields,
            },
          });
        }
      });
      video.addEventListener("timeupdate", function () {
        let percent = Math.ceil((this.currentTime / this.duration) * 100);
        if (this.percent !== percent && percent !== 0 && percent % 5 === 0) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video percentage watched", {
              "video percentage watched": {
                "video percentage watched": percent,
                ...vm.$root.ymFields,
              },
            });
          }
          this.percent = percent;
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.intervalEnd);
  },
  watch: {
    async timerResult() {
      if (!Object.keys(this.timerResult).length) {
        this.fetchIframeAccess(this.EventDetail.id);
        clearInterval(this.interval);
        clearInterval(this.intervalEnd);
      }
    },
    async EventDetail() {
      if (this.EventDetail.external) {
        window.open(this.EventDetail.external_link, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup__text {
  font-family: "Roboto Slab", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
  color: #656969;
}
.timer {
  &__value {
    margin-right: 16px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;

    @media screen and (max-width: 767px) {
      margin-right: 0;
      font-size: 32px;
      line-height: 38px;
    }
  }

  &__text {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 22px;
    }
  }
}
.event-detail {
  padding-top: 64px;
  @media screen and (max-width: 1220px) {
    padding-top: 40px;
  }

  &__tip {
    margin-top: 32px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #b2b4b4;
  }

  &__description-block {
    margin-bottom: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 48px;
    background-color: #f8f8f8;

    & img {
      height: 220px;
      @media screen and (max-width: 1220px) {
        width: 100%;
        height: auto;
      }

      @media screen and (max-width: 767px) {
        margin: 0 auto;
      }
    }

    @media screen and (max-width: 1220px) {
      display: block;
      padding: 24px;
    }

    @media screen and (max-width: 767px) {
      display: block;
      padding: 16px;
    }
  }

  video {
    width: 100%;
    height: auto;
  }

  &__banner {
    width: 100%;
  }

  &__timer {
    margin-bottom: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 37px;
    background-color: #f0ab00;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #fff;
    position: relative;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      align-items: flex-start;
    }

    @media screen and (max-width: 767px) {
      padding: 16px;
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 23px;
      line-height: 29px;
      margin-right: auto;

      @media screen and (max-width: 1220px) {
        margin-right: 0;
        margin-bottom: 32px;
      }

      @media screen and (max-width: 767px) {
        font-size: 21px;
        line-height: 26px;
      }
    }

    &-item {
      margin-right: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:last-child {
        margin-right: 0;
      }

      @media screen and (max-width: 1220px) {
        margin-right: auto;
      }

      @media screen and (max-width: 767px) {
        flex-direction: column;
        margin-right: auto;
      }
    }

    &-row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 1220px) {
        width: 100%;
      }
    }

    &-date {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 48px;
      color: #ffffff;

      @media screen and (max-width: 767px) {
        font-size: 26px;
      }
    }
  }

  &__iframe {
    position: relative;
    width: 100%;
    display: none;

    & iframe {
      width: 100%;
      height: 800px;

      @media screen and (max-width: 1220px) {
        width: 100%;
        height: 100%;
      }
    }

    @media screen and (max-width: 1220px) {
      display: none;
    }
  }

  &__iframe_opened {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    padding: 64px;

    & iframe {
      height: 100%;
    }

    @media screen and (max-width: 1220px) {
      padding: 0;
    }
  }

  &__close-btn {
    cursor: pointer;
    position: absolute;
    top: 24px;
    left: 24px;
    z-index: 2;

    @media screen and (max-width: 1220px) {
      top: 0;
      right: 50%;
      transform: translateX(50%);
    }
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;

    @media screen and (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  &__translation {
    max-width: 280px;

    @media screen and (max-width: 1220px) {
      width: auto;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
      max-width: none;
    }
  }

  &__date-info {
    border-left: 4px solid #0194ac;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 24px;
    margin-top: 64px;
    margin-bottom: 40px;
    background-color: #f8f8f8;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      margin-top: 40px;
    }

    @media screen and (max-width: 767px) {
      margin-top: 32px;
    }
  }

  &__about-title {
    margin-bottom: 24px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #3c4242;
  }

  &__about-description {
    margin-bottom: 32px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #656969;
  }

  &__date-text {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
    }
  }

  &__date-item {
    margin-right: 32px;

    @media screen and (max-width: 1220px) {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }

  &__date-item-title {
    margin-bottom: 4px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #b2b4b4;
  }

  &__date-item-value {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #3c4242;
  }

  &__add-calendar {
    width: 280px;
    margin-left: auto;
    @media screen and (max-width: 1220px) {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.hobl {
  &__program {
    &-item {
      margin-bottom: 48px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      &:last-child {
        margin-bottom: 0;
      }

      @media screen and (max-width: 767px) {
        flex-direction: column;
      }
    }

    &-time {
      width: fit-content;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #2186af;
      padding: 4px 8px;
      border-radius: 99px;
      background-color: #f8f8f8;
      margin-right: auto;

      @media screen and (max-width: 767px) {
        margin-bottom: 16px;
      }
    }

    &-info {
      width: 65%;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    &-title {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #3c4242;
    }

    &-description {
      margin-top: 8px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #656969;
    }
  }

  &-activities {
    &__title {
      margin-bottom: 24px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 23px;
      line-height: 29px;
      color: #1f1f1f;
    }

    &__description {
      margin-bottom: 24px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #3c4242;
    }

    &__list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      column-gap: 32px;
      row-gap: 32px;

      @media screen and (max-width: 1219px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media screen and (max-width: 767px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    &__item {
      padding: 40px 22px;
      background: #f8f8f8;
      border-radius: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  &-activity {
    &__icon {
      height: 117px;
      margin-bottom: 32px;

      & img {
        height: 100%;
      }
    }

    &__button {
      width: 100%;
      border: 1px solid #2186af;
      color: #2186af;
      background-color: transparent;

      &:hover {
        border-color: #2eb5eb;
        color: #2eb5eb;
      }
    }
  }
}
.event-detail {
  i {
    font-style: italic !important;
  }

  b,
  strong {
    font-weight: 500 !important;
  }

  ul {
    list-style: disc;
    padding-left: 18px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
  }

  ol {
    list-style: decimal;
    padding-left: 18px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
  }

  li {
    margin-bottom: 8px;

    & > ul {
      margin-top: 8px;

      & li {
        color: #656969;
        list-style-type: none;
      }
    }
  }
}
</style>
